import { useContext, useEffect, useState } from 'react';
import { MigrationBtn } from './MigrationBtn';
import { MigrationModal } from './MigrationModal';
import { MigrationProvider } from './context/Migration_context';
import { AuthContext } from '@f_context/Auth_context';
import { QwepContext } from '@f_qwep/context/Qwep_context';
import { UserContext } from '@f_context/User_context';

export const Migration = () => {
    const { accountInfo } = useContext(AuthContext);
    const { activeApp } = useContext(QwepContext);
    const { userRole } = useContext(UserContext);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const isSuperAdmin = userRole.some((item) => item.includes('SUPER_ADMIN') || item.includes('admin'));
        const createBy = accountInfo?.user?.createBy === 0 || accountInfo?.user?.createBy === null;
        if (createBy && activeApp && isSuperAdmin) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [accountInfo, activeApp, userRole]);

    if (show) {
        return (
            <MigrationProvider>
                <MigrationBtn />
                <MigrationModal />
            </MigrationProvider>
        );
    }
};
